/* Kiraal Refined 1.0. Presentation only: no cart endpoints or additional tracking. */
(function () {
  'use strict';
  if (!document.body.classList.contains('kiraal-refined')) return;
  var controllers = new Map();
  var mobile = window.matchMedia('(max-width: 1007px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function stockState(variant, threshold) {
    if (!variant) return 'unavailable';
    if (!variant.available) return 'sold_out';
    if (!variant.tracked) return 'available';
    if (variant.quantity <= 0) return 'backorder';
    if (variant.quantity < threshold) return 'low_stock';
    return 'stock';
  }

  function init(form, dataNode) {
    if (controllers.has(form)) return;
    var data;
    try { data = JSON.parse(dataNode.textContent); }
    catch (error) { return; }
    if (!Array.isArray(data.variants)) return;
    var mainButton = form.querySelector('.ProductForm__AddToCart');
    if (!mainButton) return;
    var section = form.closest('[data-section-id]') || form.parentElement;
    var stock = form.querySelector('[data-kr-stock]');
    var stockText = stock && stock.querySelector('[data-kr-stock-text]');
    var sticky = section.querySelector('[data-kr-sticky]');
    if (sticky && sticky.dataset.productId !== String(data.productId)) sticky = null;
    var stickyButton = sticky && sticky.querySelector('[data-kr-sticky-button]');
    var stickyPrice = sticky && sticky.querySelector('[data-kr-sticky-price]');
    var variants = new Map(data.variants.map(function (v) { return [String(v.id), v]; }));
    var input = form.querySelector('[name="id"]');
    var selected = variants.get(String(input ? input.value : data.selectedId)) || null;
    var disposers = [], frame = 0, lastHeight = 0;
    if (stock) form.classList.add('kr-stock-enabled');

    function on(node, type, callback, options) {
      node.addEventListener(type, callback, options);
      disposers.push(function () { node.removeEventListener(type, callback, options); });
    }
    function syncButton() {
      if (!stickyButton) return;
      stickyButton.disabled = mainButton.disabled || !selected || !selected.available;
      var label = mainButton.textContent.replace(/\s+/g, ' ').trim();
      if (stickyButton.textContent !== label) stickyButton.textContent = label;
      if (mainButton.getAttribute('aria-busy') === 'true') {
        stickyButton.setAttribute('aria-busy', 'true');
      } else {
        stickyButton.removeAttribute('aria-busy');
      }
    }
    function update(variant) {
      selected = variant;
      if (stock && stockText) {
        var state = stockState(variant, Number(data.threshold) || 20);
        stock.dataset.state = state;
        stockText.textContent = data.labels[state] || '';
      }
      if (stickyPrice) stickyPrice.textContent = variant ? variant.priceText : '';
      syncButton();
      schedule();
    }
    function visibility() {
      frame = 0;
      if (!sticky) return;
      var active = document.activeElement;
      var editing = active && (active.matches('input,textarea,select') || active.isContentEditable);
      var overlay = document.querySelector('.Drawer[aria-hidden="false"],.Modal[aria-hidden="false"],.Search[aria-hidden="false"],dialog[open]');
      var shown = document.body.classList.contains('kiraal-refined') && mobile.matches && !editing && !overlay && mainButton.getClientRects().length > 0 && mainButton.getBoundingClientRect().bottom < 0;
      sticky.hidden = !shown;
      if (shown) {
        var height = Math.ceil(sticky.getBoundingClientRect().height);
        if (height !== lastHeight) {
          document.body.style.setProperty('--kr-sticky-height', height + 'px');
          lastHeight = height;
        }
      }
      document.body.classList.toggle('kr-has-sticky', Boolean(shown));
    }
    function schedule() {
      if (sticky && !frame) frame = window.requestAnimationFrame(visibility);
    }
    on(section, 'variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      if (variant && !variants.has(String(variant.id))) return;
      update(variant ? variants.get(String(variant.id)) || null : null);
    });
    // Prestige emits variant:changed for option selectors. This fallback is for native id selectors only.
    on(form, 'change', function (event) {
      if (event.target && event.target.name === 'id') {
        update(variants.get(String(event.target.value)) || null);
      }
    });
    var buttonObserver = new MutationObserver(syncButton);
    buttonObserver.observe(mainButton, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['disabled','aria-busy']});
    disposers.push(function () { buttonObserver.disconnect(); });

    if (sticky && stickyButton) {
      on(stickyButton, 'click', function () {
        // Do not build a second form or POST. Existing validation, apps and tracking stay in charge.
        if (stickyButton.disabled || mainButton.disabled) return;
        if (!form.reportValidity()) {
          mainButton.scrollIntoView({behavior:reducedMotion.matches ? 'auto' : 'smooth', block:'center'});
          return;
        }
        mainButton.click();
      });
      on(window, 'scroll', schedule, {passive:true});
      on(window, 'resize', schedule, {passive:true});
      on(document, 'focusin', schedule);
      on(document, 'focusout', schedule);
      var overlayObserver = new MutationObserver(schedule);
      overlayObserver.observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['aria-hidden','open']});
      disposers.push(function () { overlayObserver.disconnect(); });
    }
    controllers.set(form, {
      destroy:function () {
        disposers.forEach(function (dispose) { dispose(); });
        if (frame) window.cancelAnimationFrame(frame);
        if (sticky) { sticky.hidden = true; document.body.classList.remove('kr-has-sticky'); }
        form.classList.remove('kr-stock-enabled');
        controllers.delete(form);
      }
    });
    update(selected);
  }
  function scan(root) {
    root.querySelectorAll('form [data-kr-product]').forEach(function (node) {
      var form = node.closest('form');
      if (form) init(form, node);
    });
  }
  function openHashTarget() {
    if (!window.location.hash) return;
    var id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); }
    catch (error) { return; }
    var target = document.getElementById(id);
    var details = target && target.closest('details.KiraalDescription');
    if (details) details.open = true;
  }
  scan(document);
  openHashTarget();
  window.addEventListener('hashchange', openHashTarget);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (controller, form) {
      if (event.target.contains(form)) controller.destroy();
    });
  });
}());
